var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

/* eslint-env browser */
module.exports = function (source) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var matcher, decoder, buffer, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, parts, i;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            matcher = /\r?\n/;
            decoder = new TextDecoder('utf8');
            buffer = '';
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 5;
            _iterator = _asyncIterator(source);

          case 7:
            _context.next = 9;
            return _awaitAsyncGenerator(_iterator.next());

          case 9:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 13;
            return _awaitAsyncGenerator(_step.value);

          case 13:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 30;
              break;
            }

            chunk = _value;

            if (typeof chunk === 'string') {
              chunk = new TextEncoder().encode(chunk);
            }

            buffer += decoder.decode(chunk, {
              stream: true
            });
            parts = buffer.split(matcher);
            buffer = parts.pop();
            i = 0;

          case 21:
            if (!(i < parts.length)) {
              _context.next = 27;
              break;
            }

            _context.next = 24;
            return JSON.parse(parts[i]);

          case 24:
            i++;
            _context.next = 21;
            break;

          case 27:
            _iteratorNormalCompletion = true;
            _context.next = 7;
            break;

          case 30:
            _context.next = 36;
            break;

          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 36:
            _context.prev = 36;
            _context.prev = 37;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 41;
              break;
            }

            _context.next = 41;
            return _awaitAsyncGenerator(_iterator.return());

          case 41:
            _context.prev = 41;

            if (!_didIteratorError) {
              _context.next = 44;
              break;
            }

            throw _iteratorError;

          case 44:
            return _context.finish(41);

          case 45:
            return _context.finish(36);

          case 46:
            buffer += decoder.decode();

            if (!buffer) {
              _context.next = 50;
              break;
            }

            _context.next = 50;
            return JSON.parse(buffer);

          case 50:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 32, 36, 46], [37,, 41, 45]]);
  }))();
};